type DebugSettings = {
  showTechnicalInfo: boolean
}

const STORAGE_KEY = 'debug.showTechnicalInfo'

function readBoolFromStorage(key: string): boolean {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return false
    if (raw === '1' || raw === 'true') return true
    if (raw === '0' || raw === 'false') return false
    // JSON boolean fallback
    const j = JSON.parse(raw)
    return Boolean(j)
  } catch {
    return false
  }
}

function writeBoolToStorage(key: string, value: boolean) {
  try {
    localStorage.setItem(key, value ? '1' : '0')
  } catch {
    // ignore (private mode / storage blocked)
  }
}

export function getShowTechnicalInfo(): boolean {
  return readBoolFromStorage(STORAGE_KEY)
}

export function setShowTechnicalInfo(value: boolean): void {
  writeBoolToStorage(STORAGE_KEY, value)
  try {
    window.dispatchEvent(new CustomEvent('debugSettings:change'))
  } catch {
    // ignore
  }
}

export function getDebugSettings(): DebugSettings {
  return { showTechnicalInfo: getShowTechnicalInfo() }
}

export function subscribeToDebugSettings(callback: (next: DebugSettings) => void): () => void {
  const emit = () => callback(getDebugSettings())

  // initial
  emit()

  const onStorage = (e: StorageEvent) => {
    if (e.key !== STORAGE_KEY) return
    emit()
  }
  const onCustom = () => emit()

  window.addEventListener('storage', onStorage)
  window.addEventListener('debugSettings:change', onCustom as EventListener)

  return () => {
    window.removeEventListener('storage', onStorage)
    window.removeEventListener('debugSettings:change', onCustom as EventListener)
  }
}

